export const getSelectedRetailerId = (state) =>
  state.excelOrdersModal.selectedRetailerId
export const getRetailerSearchText = (state) =>
  state.excelOrdersModal.retailerSearchText
